import * as _ from "lodash";
import { BaseModel } from "./base-model";

export class EnumData extends BaseModel{
	name: string;
	value: number;

	constructor(data: any){
		super(data);
	}
}



// WEBPACK FOOTER //
// ./src/stores/models/enum-data.ts